module.exports = __webpack_public_path__ + "img/img_gotoconnect.5bc218bc.jpg";